import { Box, Button, DialogActions, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { dialogButtonCancel } from '../../../../utils/commonStyle';
import { useTheme } from '@emotion/react';
import AddShip from '../../../../assets/images/addShip.svg';
import { useSelector } from 'react-redux';
import { checkPermission } from '../../../../redux/features/authSlice';
import { useTranslation } from 'react-i18next';

export default function FleetDetails({ setOpenAddVoyage, setOpenEditShip, details, isArchived }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;
  const shipPermission = useSelector((state) => checkPermission(state, 'Fleet Management', 'Manage ships'));
  const voyagePermission = useSelector((state) => checkPermission(state, 'Fleet Management', 'Manage Voyages'));
  const {t} = useTranslation()
  return (
    <Stack className="flex-overflow pt-2">
      <Stack
        direction={'row'}
        className="px-[16px] !mb-[16px] !mt-[16px]"
      >
        <Stack flex={0.55}>
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
           {t('Ship name')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.shipName || '-'}
          </Typography>
        </Stack>
        <Stack flex={0.45}>
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('Ship type')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
          >
            {details?.shipType || '-'}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        direction={'row'}
        className="px-[16px] !mb-[16px]"
      >
        <Stack flex={0.55}>
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('IMO no')}.
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.imoNumber || '-'}
          </Typography>
        </Stack>
        <Stack flex={0.45}>
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('Summer deadweight')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
          >
            {details?.summerDeadWeight?.toLocaleString() || '0'}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        style={{ backgroundColor: '#14285A1A', height: '1px' }}
        className="!my-[16px] !mx-[16px] !mr-[16px]"
      />
      <Stack
        direction={'row'}
        className="px-[16px] !mb-[16px]"
      >
        <Stack flex={0.55}>
          <Typography
            className="fs-12 ff-Roboto fw-regular"
            color={text}
          >
            {t('Owner')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.owner || '-'}
          </Typography>
        </Stack>
        <Stack flex={0.45}>
          <Typography
            className="fs-12 ff-Roboto fw-regular"
            color={text}
          >
            {t('Charterer')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
          >
            {details?.charterer || '-'}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        direction={'row'}
        className="px-[16px] !mb-[16px]"
      >
        <Stack flex={0.55}>
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('MRV company')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.manager || '-'}
          </Typography>
        </Stack>
        <Stack flex={0.45}>
          <Typography
            className="fs-12 ff-Roboto fw-regular"
            color={text}
          >
            {t('Operator')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
          >
            {details?.operator || '-'}
          </Typography>
        </Stack>
      </Stack>

      <Stack
        direction={'row'}
        className="px-[16px] !mb-[16px]"
      >
        <Stack flex={0.55}>
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('Data owner')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.dataOwner || '-'}
          </Typography>
        </Stack>
        <Stack flex={0.45}>
          <Typography
            className="fs-12 ff-Roboto fw- !capitalize"
            color={text}
          >
            {t('EU ETS Verifier')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
          >
            {details?.euMrvDatabaseType || '-'}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        style={{ backgroundColor: '#14285A1A', height: '1px' }}
        className="!my-[16px] !mx-[16px] !mr-[16px]"
      />
      <Stack
        style={{ borderWidth: '1px', borderColor: '#14285A26', borderRadius: '8px' }}
        className="!p-[16px] mx-[16px]"
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
        >
          <Typography
            className="fs-12 ff-Roboto fw-medium !mb-[12px] !capitalize"
            color={text}
            flex={1}
          >
            {t('Fuel type')}
          </Typography>
          <Stack flex={1}>
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={text}
            >
             {t('Emission factor')}
            </Typography>
            <Typography
              className="fs-10 ff-Roboto fw-medium"
              color={textLight}
            >
              t CO2/ t {t('Fuel')}
            </Typography>
          </Stack>
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-medium capitalize"
              color={text}
            >
              {t('laden')}
            </Typography>
            <Typography
              className="fs-10 ff-Roboto fw-medium"
              color={textLight}
            >
              C/P
            </Typography>
          </Stack>
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={text}
            >
              {t('ballast')}
            </Typography>
            <Typography
              className="fs-10 ff-Roboto fw-medium"
              color={textLight}
            >
              C/P
            </Typography>
          </Stack>
        </Stack>
        <Stack
          style={{ backgroundColor: '#14285A1A', width: '100%', height: '1px' }}
          className="!my-[16px] !mr-[16px]"
        />
        {details?.fuelType?.map((item, index) => (
          <Stack
            direction={'row'}
            alignItems={'center'}
            style={{ marginTop: index > 0 ? '16px' : '0px' }}
          >
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={text}
              flex={1}
            >
              {item.fuelType}
            </Typography>
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={textLight}
              flex={1}
            >
              {item?.emissionFactor}
            </Typography>
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={textLight}
              flex={0.5}
            >
              {item?.dailyConsumptionCperPLaden || '-'}
            </Typography>
            <Typography
              className="fs-12 ff-Roboto fw-medium"
              color={textLight}
              flex={0.5}
            >
              {item?.dailyConsumptionCperPBallest || '-'}
            </Typography>
          </Stack>
        ))}
      </Stack>
      <Stack flexGrow={1} />
      {!isArchived &&   <Stack
        direction="row"
        alignItems={'center'}
        justifyContent="space-between"
        className="px-4 sticky bottom-[0] !mt-[40px] !py-[10px]"
        // className="!mt-[44px] h-[66px] "
        style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
      >
        {voyagePermission.addAccess && <Button
          sx={[
            dialogButtonCancel,
            {
              color: theme.palette.primary.main,
              '&:hover': {},
            },
          ]}
          style={{ width: '148px', height: '40px' }}
          onClick={() => {
            setOpenAddVoyage();
            // setType('add');
            // setSelectedData([[]]);
          }}
        >
          <img
            src={AddShip}
            style={{ marginRight: '5px' }}
          />
          <Typography
            color={theme.palette.primary.main}
            className="fs-14 ff-Roboto fw-medium !ml-[5px] !uppercase"
          >
           {t('Add voyage')}
          </Typography>
        </Button>}
        {shipPermission.editAccess && <Button
          variant="outlined"
          sx={[
            dialogButtonCancel,
            {
              color: theme.palette.primary.main,
              textTransform: 'uppercase',
              '&:hover': {
                backgroundColor: '#14285A12',
              },
            },
          ]}
          style={{ width: '128px', height: '40px', borderColor: '#14285A4D', borderWidth: '1px' }}
          onClick={() => {
            setOpenEditShip();
          }}
        >
          {t('Edit details')}
        </Button>}
      </Stack> }
     
    </Stack>
  );
}
